export const filteredUsersMixin = {
  data() {
    return {};
  },
  computed: {
    completedActiveAssessment() {
      if (this.userData.length > 0) {
        return this.userData
          .filter(
            user =>
              user.assessmentStates[0].threads[this.threadId].progress === 100
          )
          .filter(user => {
            return (
              user.assessmentStates[0].feedback.length > 0 &&
              user.assessmentStates[0].feedback.find(
                thread => thread.threadId === this.threadId + 1
              )
            );
          });
      }
      return [];
    }
  },
  methods: {}
};
